/*
 * Variant selector form handler for product grid items
 * Uses event delegation — only needs to load once for all forms on the page
 */
(function() {
  if (window.__variantSelectorInit) return;
  window.__variantSelectorInit = true;

  document.addEventListener('submit', function(e) {
    if (!e.target.classList.contains('variant-selector-form')) return;

    e.preventDefault();
    var form = e.target;
    var select = form.querySelector('.variant-selector');
    var addBtn = form.querySelector('.variant-add-to-cart');
    var errorMsg = form.querySelector('.variant-cart-error');
    errorMsg.style.display = 'none';
    addBtn.disabled = true;

    var variantId = select.value;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(resp) {
      if (!resp.ok) throw new Error('Cart add failed');
      return resp.json();
    })
    .then(function() {
      // Use theme's built-in cart refresh — fetches updated cart HTML and opens drawer
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    })
    .catch(function() {
      errorMsg.textContent = 'Could not add to cart. Please try again.';
      errorMsg.style.display = 'block';
    })
    .finally(function() {
      addBtn.disabled = false;
    });
  });
})();
